import React, { useEffect } from 'react';

const useReveal = () => {
  useEffect(() => {
    const targets = document.querySelectorAll('.gc-reveal');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.15 }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
};

const AboutPage = () => {
  useReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="gc-about-page">
      {/* ── ページヒーロー ── */}
      <section className="gc-about-page__hero">
        <div className="gc-about-page__hero-inner">
          <span className="gc-section-en">About</span>
          <h1 className="gc-about-page__hero-title">GURI COFFEEについて</h1>
        </div>
      </section>

      {/* ── 自己紹介 ── */}
      <section className="gc-section gc-about-page__section">
        <div className="gc-about-page__block gc-reveal">
          <span className="gc-section-en">Introduction</span>
          <h2 className="gc-section-title">石川・南加賀から届く一杯</h2>
          <p className="gc-about-page__text">
            GURI COFFEEは、石川県南加賀エリアを拠点とするファントムロースターです。
          </p>
          <p className="gc-about-page__text">
            実店舗は持っていません。<br />
            「地元を盛り上げたい」——その気持ちだけで立ち上げました。
          </p>
          <p className="gc-about-page__text">
            私たちの拠点・南加賀は、1300年の歴史を誇る温泉地。<br />
            この土地の空気と、ここに流れるゆったりとした時間が、GURI COFFEEの原点にあります。
          </p>
        </div>
      </section>

      {/* ── コンセプト ── */}
      <section className="gc-section gc-about-page__section gc-about-page__section--dark">
        <div className="gc-about-page__block gc-reveal">
          <span className="gc-section-en">Concept</span>
          <h2 className="gc-section-title gc-section-title--light">余白にコーヒーを。</h2>
          <p className="gc-about-page__text gc-about-page__text--light">
            どれだけ忙しくても、コーヒーを淹れているこの時だけは、あなただけの時間。
          </p>
          <p className="gc-about-page__text gc-about-page__text--light">
            一息つける瞬間に寄り添えるコーヒーを、準備しております。
          </p>
        </div>
      </section>

      {/* ── 焙煎のこだわり ── */}
      <section className="gc-section gc-about-page__section">
        <div className="gc-about-page__block gc-reveal">
          <span className="gc-section-en">Roasting</span>
          <h2 className="gc-section-title">焙煎のこだわり</h2>
          <p className="gc-about-page__text">
            使用する豆は、グアテマラ産のみ。
          </p>
          <p className="gc-about-page__text">
            焙煎には相性があると考えています。<br />
            さまざまな産地の豆と向き合う中で、最も良さを引き出せたのがグアテマラ産でした。
          </p>
          <p className="gc-about-page__text">
            グアテマラ特有の深いコクと芳醇な香り。<br />
            その一杯を、どうぞゆっくりお楽しみください。
          </p>
        </div>
      </section>

      {/* ── 想い ── */}
      <section className="gc-section gc-about-page__section gc-about-page__section--dark">
        <div className="gc-about-page__block gc-reveal">
          <span className="gc-section-en">Vision</span>
          <h2 className="gc-section-title gc-section-title--light">これから</h2>
          <p className="gc-about-page__text gc-about-page__text--light">
            グアテマラのコーヒー農園と、直接取引でつながっていきたい。
          </p>
          <p className="gc-about-page__text gc-about-page__text--light">
            生産者の顔が見える関係を築き、<br />
            一杯のコーヒーの向こう側にある物語まで届けられるロースターでありたいと考えています。
          </p>
        </div>
      </section>
    </main>
  );
};

export default AboutPage;
